module.exports = __webpack_public_path__ + "static/media/u.bf85f1ef.svg";